import Icon from 'vue-awesome/components/Icon'

Icon.register({
  flash_on_rounded: {
    paths: [
      {
        d: 'M7 3v9c0 .55.45 1 1 1h2v7.15c0 .51.67.69.93.25l5.19-8.9a.995.995 0 00-.86-1.5H13l2.49-6.65A.994.994 0 0014.56 2H8c-.55 0-1 .45-1 1z'
      }
    ],
    width: '24',
    height: '24'
  }
})
